<template>
  <el-dialog :title="title" :visible.sync="dialogVisible">
    <div class="code-center">
      <slot name="codeHead">
        <p>扫码查看</p>
      </slot>
      <canvas ref="codeContainer"></canvas>
      <slot name="codeFooter">
        <p>{{ urlParam }}</p>
      </slot>
    </div>
    <slot name="btn">
      <div slot="footer" class="code-center">
        <el-button @click="onCancel" size="mini">关 闭</el-button>
      </div>
    </slot>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcode';

export default {
  props: {
    title: {
      type: String,
      default: '扫码下载APP',
    },
    value: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    urlParam: {
      get() {
        let paramString = [];
        if (this.params) {
          Object.keys(this.params).forEach(item => {
            paramString.push(`${item}=${this.params[item]}`);
          });
        }
        return paramString.length > 0 ? `${this.url}?${paramString.join('&')}` : this.url;
      },
    },
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    createCode(option = {}) {
      if (/^((https|http):\/\/)+[^\s]+\.[^\s]*/i.test(this.url)) {
        this.$nextTick(() => {
          QRCode.toCanvas(this.$refs.codeContainer, this.urlParam, option, function(error) {
            if (error) {
              console.error('二维码生成失败：', error);
            }
          });
        });
      } else {
        this.dialogVisible = false;
        this.api.toast('地址不对，请检查后重试', 'error');
      }
    },
    onCancel() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.code-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #eaeaea;
  padding: 20px;
}
/deep/ .el-dialog__footer {
  padding: 20px;
  border-top: 1px solid #eaeaea;
}
</style>
